<!--
 * @Descripttion: 按钮属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-28 14:26:19
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-06 17:09:10
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 按钮设置 -->
    <el-collapse-item title="按钮设置">
      <el-form-item label="按钮项">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="onAdd"
        >新增</el-button>
      </el-form-item>

      <div style="padding-bottom: 20px">
        <el-table
          :data="data.option.column"
          v-loading="waitting"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column label="按钮名">
            <template slot-scope="scope">
              {{scope.row.text}}
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                icon="el-icon-top"
                @click="sortField(scope.row, scope.$index, 'up')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-bottom"
                @click="sortField(scope.row, scope.$index, 'down')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="editField(scope.row, scope.$index)"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="deleteField(scope.row, scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 弹窗 -->
        <button-field-dialog
          :dialog="dialog"
          :data="data"
          :column="column"
          @change="updateField($event, onRefresh)"
        />

      </div>

      <el-form-item label="显示设备">
        <el-radio-group
          v-model="data.option.device"
          size="small"
        >
          <el-radio-button label="desktop">PC</el-radio-button>
          <el-radio-button label="mobile">Mobile</el-radio-button>
          <el-radio-button label="">两端显示</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="对齐方式">
        <el-select
          v-model="data.option.align"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  theme,
  predefineColors,
  component,
  buttonConfig
} from '@/dragComponents/model/default.js'
import apiField from '@/dragComponents/mixins/apiField.js'
import { deepClone } from '@/dragComponents/utils'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import buttonFieldDialog from './dialog.vue'

export default {
  name: 'config-button',
  mixins: [apiField],
  components: {
    configBase,
    configAuth,
    buttonFieldDialog
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      alignList: component.alignType
    }
  },
  methods: {
    onAdd() {
      let form = deepClone(buttonConfig.attrs)
      this.addField(form, false)
    }
  }
}
</script>
